/**
 * [item 1, PR !901] Largura MÁXIMA do rótulo (nome) nos triggers de
 * `SeletorEstabelecimento`/`SeletorLivro` — compartilhada pelos dois, de propósito: o pedido
 * era "largura automática até o mesmo máximo", então os dois leem esta MESMA constante em vez
 * de dois valores hardcoded que podem divergir com o tempo. Abaixo desse teto o nome aparece
 * inteiro (o trigger cresce com o conteúdo); só acima dele é que trunca com "…".
 *
 * `max-w-xs` = 20rem = 320px (escala padrão do Tailwind) — generoso o bastante pra nomes de
 * empresa comuns (ex. "Construtora Manuella Ltda") sem cortar, mas com um teto pra não deixar
 * o trigger ocupar a barra inteira com um nome excepcionalmente longo.
 */
export const LARGURA_MAX_ROTULO_SELETOR = 'max-w-xs';
